import { render, staticRenderFns } from "./AddCamera.vue?vue&type=template&id=5f9f6adc&scoped=true&"
import script from "./AddCamera.vue?vue&type=script&lang=ts&"
export * from "./AddCamera.vue?vue&type=script&lang=ts&"
import style0 from "./AddCamera.vue?vue&type=style&index=0&id=5f9f6adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9f6adc",
  null
  
)

component.options.__file = "AddCamera.vue"
export default component.exports